(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__testimonialsCarouselDefined) return;
    window.__testimonialsCarouselDefined = true;

    function TestimonialsCarousel(root) {
      this.root = root;
      this.viewport = root.querySelector('[data-track]').parentElement;
      this.track = root.querySelector('[data-track]');
      this.slides = Array.prototype.slice.call(this.track.children);
      this.dotsWrap = root.querySelector('[data-dots]');
      this.prevBtn = root.querySelector('[data-prev]');
      this.nextBtn = root.querySelector('[data-next]');

      this.autoplay = root.dataset.autoplay === 'true';
      this.autoplaySpeed = (parseFloat(root.dataset.autoplaySpeed) || 5) * 1000;
      this.transitionSpeed = parseInt(root.dataset.transitionSpeed, 10) || 600;
      this.pauseOnHover = root.dataset.pauseOnHover === 'true';
      this.infinite = root.dataset.infinite === 'true';

      this.realCount = this.slides.length;
      this.perView = 1;
      this.cloneCount = 0;
      this.index = 0;
      this.timer = null;
      this.isDragging = false;
      this.dragStartX = 0;
      this.dragDelta = 0;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.realCount > 1 && this.infinite) {
        this.setupClones();
      }

      this.onResize = this.onResize.bind(this);
      this.onPointerDown = this.onPointerDown.bind(this);
      this.onPointerMove = this.onPointerMove.bind(this);
      this.onPointerUp = this.onPointerUp.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.measure();
      this.buildDots();
      this.bindEvents();
      this.goTo(this.infinite ? this.cloneCount : 0, false);
      this.updateArrows();
      if (this.autoplay && !this.reducedMotion) this.play();
    }

    TestimonialsCarousel.prototype.setupClones = function () {
      var count = Math.min(this.realCount, this.maxPerView());
      this.cloneCount = count;
      var head = this.slides.slice(0, count).map(function (n) { return n.cloneNode(true); });
      var tail = this.slides.slice(-count).map(function (n) { return n.cloneNode(true); });
      tail.forEach(function (n) { n.setAttribute('aria-hidden', 'true'); this.track.insertBefore(n, this.track.firstChild); }.bind(this));
      head.forEach(function (n) { n.setAttribute('aria-hidden', 'true'); this.track.appendChild(n); }.bind(this));
      this.slides = Array.prototype.slice.call(this.track.children);
    };

    TestimonialsCarousel.prototype.maxPerView = function () {
      return Math.max(
        parseInt(getComputedStyle(this.root).getPropertyValue('--testimonials-cards-desktop'), 10) || 3,
        1
      );
    };

    TestimonialsCarousel.prototype.getPerView = function () {
      var width = window.innerWidth;
      var styles = getComputedStyle(this.root);
      if (width >= 990) return parseInt(styles.getPropertyValue('--testimonials-cards-desktop'), 10) || 3;
      if (width >= 750) return parseInt(styles.getPropertyValue('--testimonials-cards-tablet'), 10) || 2;
      return parseInt(styles.getPropertyValue('--testimonials-cards-mobile'), 10) || 1;
    };

    TestimonialsCarousel.prototype.measure = function () {
      this.perView = this.getPerView();
      var viewportWidth = this.viewport.getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      this.slideWidth = (viewportWidth - gap * (this.perView - 1)) / this.perView;
      this.gap = gap;
    };

    TestimonialsCarousel.prototype.buildDots = function () {
      if (!this.dotsWrap) return;
      this.dotsWrap.innerHTML = '';
      var pages = Math.max(Math.ceil(this.realCount / this.perView), 1);
      this.pages = pages;
      for (var i = 0; i < pages; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'testimonials-carousel__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to testimonial page ' + (i + 1));
        dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        dot.addEventListener('click', this.goToPage.bind(this, i));
        this.dotsWrap.appendChild(dot);
      }
    };

    TestimonialsCarousel.prototype.updateDots = function () {
      if (!this.dotsWrap) return;
      var offset = this.infinite ? this.cloneCount : 0;
      var page = Math.round((this.index - offset) / this.perView) % this.pages;
      if (page < 0) page += this.pages;
      Array.prototype.forEach.call(this.dotsWrap.children, function (dot, i) {
        dot.setAttribute('aria-current', i === page ? 'true' : 'false');
      });
    };

    TestimonialsCarousel.prototype.goToPage = function (page) {
      var offset = this.infinite ? this.cloneCount : 0;
      this.goTo(offset + page * this.perView, true);
      this.restart();
    };

    TestimonialsCarousel.prototype.updateArrows = function () {
      if (this.infinite || !this.prevBtn) return;
      this.prevBtn.disabled = this.index <= 0;
      this.nextBtn.disabled = this.index >= this.realCount - this.perView;
    };

    TestimonialsCarousel.prototype.goTo = function (index, animate) {
      this.index = index;
      var x = -(index * (this.slideWidth + this.gap));
      this.track.style.transition = animate && !this.reducedMotion ? 'transform ' + this.transitionSpeed + 'ms cubic-bezier(0.4, 0, 0.2, 1)' : 'none';
      this.track.style.transform = 'translateX(' + x + 'px)';
      this.updateDots();
      this.updateArrows();
    };

    TestimonialsCarousel.prototype.next = function () {
      var next = this.index + 1;
      if (!this.infinite && next > this.realCount - this.perView) return;
      this.goTo(next, true);
      if (this.infinite) this.checkLoop();
    };

    TestimonialsCarousel.prototype.prev = function () {
      var prev = this.index - 1;
      if (!this.infinite && prev < 0) return;
      this.goTo(prev, true);
      if (this.infinite) this.checkLoop();
    };

    TestimonialsCarousel.prototype.checkLoop = function () {
      var self = this;
      if (this._loopHandler) {
        this.track.removeEventListener('transitionend', this._loopHandler);
      }
      this._loopHandler = function () {
        self.track.removeEventListener('transitionend', self._loopHandler);
        self._loopHandler = null;
        if (self.index >= self.realCount + self.cloneCount) {
          self.goTo(self.index - self.realCount, false);
        } else if (self.index < self.cloneCount) {
          self.goTo(self.index + self.realCount, false);
        }
      };
      this.track.addEventListener('transitionend', this._loopHandler);
    };

    TestimonialsCarousel.prototype.play = function () {
      this.stop();
      var self = this;
      // the very first advance fires sooner than the configured interval so autoplay
      // feels immediately responsive instead of sitting still for a full cycle first
      var firstDelay = Math.min(this.autoplaySpeed, 1200);
      this.timer = setTimeout(function () {
        self.next();
        self.timer = setInterval(function () { self.next(); }, self.autoplaySpeed);
      }, firstDelay);
    };

    TestimonialsCarousel.prototype.stop = function () {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
    };

    TestimonialsCarousel.prototype.restart = function () {
      if (this.autoplay && !this.reducedMotion) this.play();
    };

    TestimonialsCarousel.prototype.onResize = function () {
      var prevPerView = this.perView;
      this.measure();
      if (prevPerView !== this.perView) this.buildDots();
      this.goTo(this.index, false);
    };

    TestimonialsCarousel.prototype.onPointerDown = function (e) {
      this.isDragging = true;
      this.dragStartX = e.clientX || (e.touches && e.touches[0].clientX);
      this.track.classList.add('is-dragging');
      this.stop();
    };

    TestimonialsCarousel.prototype.onPointerMove = function (e) {
      if (!this.isDragging) return;
      var x = e.clientX || (e.touches && e.touches[0].clientX);
      this.dragDelta = x - this.dragStartX;
      var base = -(this.index * (this.slideWidth + this.gap));
      this.track.style.transform = 'translateX(' + (base + this.dragDelta) + 'px)';
    };

    TestimonialsCarousel.prototype.onPointerUp = function () {
      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.classList.remove('is-dragging');
      if (Math.abs(this.dragDelta) > this.slideWidth * 0.2) {
        if (this.dragDelta < 0) this.next(); else this.prev();
      } else {
        this.goTo(this.index, true);
      }
      this.dragDelta = 0;
      this.restart();
    };

    TestimonialsCarousel.prototype.onKeydown = function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); this.restart(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); this.prev(); this.restart(); }
    };

    TestimonialsCarousel.prototype.bindEvents = function () {
      var self = this;
      window.addEventListener('resize', this.onResize);

      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.next(); self.restart(); });
      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.prev(); self.restart(); });

      this.viewport.addEventListener('pointerdown', this.onPointerDown);
      window.addEventListener('pointermove', this.onPointerMove);
      window.addEventListener('pointerup', this.onPointerUp);

      this.viewport.addEventListener('keydown', this.onKeydown);

      if (this.pauseOnHover) {
        this.root.addEventListener('mouseenter', function () { self.stop(); });
        this.root.addEventListener('mouseleave', function () { self.restart(); });
        this.root.addEventListener('focusin', function () { self.stop(); });
        this.root.addEventListener('focusout', function () { self.restart(); });
      }
    };

    TestimonialsCarousel.prototype.destroy = function () {
      this.stop();
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('pointermove', this.onPointerMove);
      window.removeEventListener('pointerup', this.onPointerUp);
    };

    function init(scope) {
      (scope || document).querySelectorAll('[data-testimonials-carousel]').forEach(function (el) {
        if (el.__testimonialsInstance) return;
        if (!el.querySelector('[data-track]')) return;
        if (el.querySelectorAll('[data-slide]').length < 2) return;
        el.__testimonialsInstance = new TestimonialsCarousel(el);
      });
    }

    document.addEventListener('DOMContentLoaded', function () { init(document); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      var el = e.target.querySelector('[data-testimonials-carousel]');
      if (el && el.__testimonialsInstance) {
        el.__testimonialsInstance.destroy();
        el.__testimonialsInstance = null;
      }
    });

    if (document.readyState !== 'loading') init(document);
  })();

  } catch(e) { console.error(e); }
})();
})();
